// import React, { useState } from "react";
import React from "react"
import Header from "./Header";
import Footer from "./Footer";


 export default function Contact(){

    return(
  
       
        <div className="section">
            <div className="projects-title"><h2 id="contactme" ><span class="material-symbols-outlined bullet2">square</span>Contact Me</h2>
            </div>
            <div  className="contact-div">
            <form className="form"
            action = "https://getform.io/f/aff09102-931c-4f92-bf0c-11e660534039"
            method="POST"
            >
                 <label>Name*<br/>
                <input type="text" name= "name" /><br/>
                </label>
                <label>Email*<br/>
                <input type="email" name="email" /><br/>
                </label>
                <label>Message*<br/>
                <textarea type="text" name="message" rows={4} className="form-text-area" /><br/>
                </label>
                <button className="buttons btn1 ">SEND</button>
             </form>
            </div>
        </div>
        
    )
 }